import { PercentageProgressBar, SquareActionButton } from '@components';
import { useScreenSize } from '@hooks';
import { Flex } from '@styles';
import { bool, func, number, object, oneOf, shape, string } from 'prop-types';
import React from 'react';

const ModuleActionBar = ({
  additionalButton,
  containerProps,
  progress,
  rank,
  // report,
  sidePanel,
}) => {
  const { isTabletSM } = useScreenSize();
  return (
    <Flex
      alignItems="center"
      gap={isTabletSM ? 12 : 24}
      justifyContent="space-between"
      py="8px"
      {...containerProps}
    >
      <SquareActionButton {...sidePanel} />
      <PercentageProgressBar {...progress} />
      <Flex flexDirection="row" gap={isTabletSM ? 12 : 16} grow={0}>
        <SquareActionButton {...additionalButton} />
        {rank?.data?.name && <SquareActionButton {...rank} rank={rank?.data} />}
      </Flex>
    </Flex>
  );
};

ModuleActionBar.propTypes = {
  additionalButton: {
    isSemivisible: bool.isRequired,
    isVisible: bool.isRequired,
    onClick: func.isRequired,
    variant: oneOf(['text']).isRequired,
  }.isRequired,
  containerProps: object,
  progress: {
    containerProps: object,
    isSemivisible: bool.isRequired,
    progress: number.isRequired,
  }.isRequired,
  rank: {
    data: shape.isRequired,
    isSemivisible: bool.isRequired,
    isVisible: bool.isRequired,
    onClick: func.isRequired,
    variant: string.isRequired,
  },
  report: {
    isSemivisible: bool.isRequired,
    isVisible: bool.isRequired,
    onClick: func.isRequired,
    variant: string.isRequired,
  }.isRequired,
  sidePanel: {
    isSemivisible: bool.isRequired,
    isVisible: bool.isRequired,
    onClick: func.isRequired,
    variant: string.isRequired,
  }.isRequired,
};

ModuleActionBar.defaultProps = {
  containerProps: {},
  rank: {},
};

export default ModuleActionBar;
